module.exports = __webpack_public_path__ + "img/xy-card-bg.22b40ec4.png";